/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Formik, Form ,Field} from "formik";
import { useHistory ,useLocation} from "react-router-dom";
import axios from "axios";
import { toAbsoluteUrl } from "../../_helpers";
import { FaSearch } from "react-icons/fa";
import { NODE_API_URL,BASE_URL} from "./../../../env_config";
import { toast } from 'react-toastify';

import {
    makeStyles,
    Backdrop,
} from "@material-ui/core";
import green from "material-ui/colors/green";
import red from "material-ui/colors/red";
import { BasicLab } from "./searchcomponent/BasicLab";
import { Advanced } from "./searchcomponent/Advanced";
import { Parameter } from "./searchcomponent/Parameter";
import { AdditionalLab } from "./searchcomponent/AdditionalLab";
import Cookies from "js-cookie";
import { Alert } from "react-bootstrap";
import ProfileComplete from "../Popup/ProfileComplete";
import SearchDiamondSkeleton from "./SearchDiamondSkeleton";

const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: red[600],
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor:"#ffffffe6!important"
      },
      noScroll: {
          overflow: 'hidden'
      }
}));

export const LabSearchDiamond = ({language,userinfo,currencyname,conversionrate,symbolname}) => {
    const location = useLocation()
    const [openLoader, setOpenLoader] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [finalFetchData, setFinalFetchData] = React.useState([]);
    const [errorMsg,setErrorMsg] = useState('');

    const [loader,setLoader] = useState(true);
    const [kycMessage,setKycMessage] = useState("")
    const [kycAlert,setAlert] = useState("")

    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/getKycMessage`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then((res) => {
            if (res && res?.data  && res?.data?.kycmessage && res?.data?.kycmessage?.kyc_status) {
                if(res?.data?.kycmessage?.message){
                    if(res?.data?.kycmessage?.kyc_status === "KYC_REJ"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message + ` ● Reason:${res?.data?.kycmessage?.reject_reason}`)
                    }
                    else if(res?.data?.kycmessage?.kyc_status === "NO_KYC"){
                        setAlert("danger")
                        setKycMessage(res?.data?.kycmessage?.message)
                    }
                }
            }
            if ((userinfo.kyc_status === "KYC_EDITED" || userinfo.kyc_status === "KYC_APPR") && !userinfo.shippingaddress) {
                setAlert("danger")
                setKycMessage("To continue with your search, please add a shipping address in the profile section.")
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[userinfo])
    const classes = useStyles();

    React.useEffect(() => {
        if (openLoader) {
            document.body.classList.add(classes.noScroll);
        } else {
            document.body.classList.remove(classes.noScroll);
        }

        // Clean up the effect
        return () => {
            document.body.classList.remove(classes.noScroll);
        };
    }, [openLoader, classes.noScroll]);

     const showSearchToast = (type, message) => {
            toast[type](message, {
                containerId: "search-toast",
                autoClose: 6000
            });
        };
  

    const enableLoading = () => {
        setOpenLoader(true);
        setIsSubmitting(true)
    };

    const disableLoading = () => {
        setOpenLoader(false);
        setIsSubmitting(false)
    };


    const history = useHistory();
    const [initialvalues,setInitialValues] = React.useState({})
    React.useEffect(() => {
        setInitialValues({})
    }, [history.location.pathname]);
    const [data, setData] = React.useState([]);
    const id = React.useMemo(() => localStorage.getItem("C_id"), []);
    const [profileModalOpen,setProfileModalOpen] = useState(false)
    function handelRest(newValue) {
        setTimeout(() => {
            localStorage.removeItem("modifysearchlab")
            window.location.reload(true);
            window.glob = newValue;
        }, 500);
    }

    const validateFilters = (values) => {

       

        const shapeSelected = Array.isArray(values.Shape) && values.Shape.length > 0;

        const caratManual =
            values.Min_Carat || values.Max_Carat;

        const caratRange = Object.keys(values).some(
            (k) => k.startsWith("CaratRange") && values[k]
        );

        const caratSelected = caratManual || caratRange;

        const anyFilterSelected = Object.keys(values).some(
            (k) =>
            values[k] !== "" &&
            values[k] !== null &&
            !(Array.isArray(values[k]) && values[k].length === 0)
        );

        if (!anyFilterSelected) {
            return "Please select at least one filter";
        }

        if (!shapeSelected && !caratSelected) {
            return "Please Select Shape and Carat to continue with search.";
        }

        if (!shapeSelected) {
            return "Please Select Shape to continue with search.";
        }

        if (!caratSelected) {
            return "Please Select Carat to continue with search.";
        }

         if (
            (values.Min_Carat === "0" || values.Min_Carat === 0) &&
            (values.Max_Carat === "0" || values.Max_Carat === 0)
        ) {
            return "0 is not allowed. in carat";
        }

        if (Number(values.Min_Carat) > Number(values.Max_Carat)) {
            return "Min carat cannot be greater than Max carat.";
        }

        // ❗ Percentage fields cannot be greater than 100
        const percentageFields = [
            "Min_Table_Prc",
            "Max_Table_Prc",
            "Min_Depth_Prc",
            "Max_Depth_Prc",
            "Min_Table",
            "Max_Table",
            "Min_Depth",
            "Max_Depth",
            "Min_Crown_Height_Prc",
            "Max_Crown_Height_Prc",
            "Min_Crown_Height",
            "Max_Crown_Height",
            "Min_Crown_Angle_Prc",
            "Max_Crown_Angle_Prc",
            "Min_Crown_Angle",
            "Max_Crown_Angle",
            "Min_Pavilion_Height_Prc",
            "Max_Pavilion_Height_Prc",
            "Min_Pavilion_Height",
            "Max_Pavilion_Height",
            "Min_Pavilion_Angle_Prc",
            "Max_Pavilion_Angle_Prc",
            "Min_Pavilion_Angle",
            "Max_Pavilion_Angle"
        ];

        for (let field of percentageFields) {
            if (values[field] && Number(values[field]) > 100) {
                return "Value cannot be greater than 100%";
            }
        }


        return null;
    };

  
    function handleData(values,oldvalues,setFieldValue) {
        const fancy = Cookies.get("fancybasic")?1:0
        window.search = values;
        const temp = {...values};
        let min = temp.Min_Price ? parseFloat(temp.Min_Price) : null;
        let max = temp.priceTo ? parseFloat(temp.priceTo) : null;

        // validation ke liye USD convert
        let minUSD = min !== null ? min / conversionrate : 0;
        let maxUSD = max !== null ? max / conversionrate : 10000;

        if (minUSD > 10000) {
        console.log("No result found");
        //setErrorMsg("No Result Found");
        showSearchToast("error", "0 Stones found please try again");
        disableLoading();
        return;
        }

        // max ko cap karo
        if (maxUSD > 10000) {
        maxUSD = 10000;
        }

        // final values set
        if (min === null) {
        temp.Min_Price = 0;
        oldvalues.Min_Price = 0;
        }

        if (max === null || maxUSD === 10000) {
        temp.priceTo = 10000 * conversionrate;
        oldvalues.priceTo = 10000 * conversionrate;
        }
        if(temp.Certi_No){
            temp.Certi_No = temp.Certi_No.replaceAll("N","").replaceAll("L","").replaceAll("-","")
        }
        let len = Object.keys(temp).length;
        let data = "";
        for (let key in temp) {
            len--;
            let arr = temp[key];
            if (len) {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" }, `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"},`;
                }
            } else {
                if (Array.isArray(arr)) {
                    let str = "";
                    str += "'" + arr.join("','") + "'";
                    data += `{"FilterName": "${key}","FilterValue":"${str}" } `;
                } else {
                    data += `{"FilterName": "${key}","FilterValue": "'${temp[key]}'"}`;
                }
            }
        }
        const finalData = `{ "JsonData":  [${data}] , "CustomerId": ${userinfo.id}, "ConsumerId":${ id === "" ? "-1" : id }, "WLDiamondType": "L" ,"page":1, "conversionrate":"${conversionrate}","curr":"${symbolname}","fancy":"${fancy}","loginLogId":${Cookies.get("_LogId")} }`;
        localStorage.setItem("modifysearchlab",JSON.stringify({...values,diamond_type:"L"}))
       
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/searchDiamond`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            },
            data: finalData,
        })
        .then(function(res) {
            if(!res.data.data.length){
                if(res?.data?.message === "Please Complete Your Profile."){
                    setProfileModalOpen(true)
                }
                else{
                    showSearchToast(
                        "error",
                        res?.data?.message || "0 Stones found please try again"
                    );
                    setErrorMsg(res?.data?.message)
                }
                disableLoading();
                if(!values.Min_Price_changed){
                    delete temp.Min_Price
                    delete oldvalues.Min_Price
                    setFieldValue("Min_Price", "")
                }

                if(!values.priceTo_changed){
                    delete temp.priceTo
                    delete oldvalues.priceTo
                    setFieldValue("priceTo", "")
                }
                return
            }
            setData([ ...data, ...res.data.data]);
            // disableLoading();
            history.push({
            pathname: `/${Cookies.get("view") || "search-result"}/L`,
            state: {
                searchresult:res.data.data,
                oldvalues:oldvalues,
                page:1
            },
            });
           
        })
        .
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
        setFinalFetchData(finalData);
    }
    React.useEffect(
        () => window.localStorage.setItem("fetchData", finalFetchData),
        [finalFetchData]
    );


    const handleInputChange = (e,formik) => {
        let value = e.target.value;
    
        value = value.replace(/\s+/g, ' ');
    
        value = value.replace(/\s/g, ',');
    
        value = value.replace(/,+/g, ',');
    
        value = value.replace(/^,/, '');
    
        formik.setFieldValue("Certi_No",value);
      };
    return (
        <>
        <ProfileComplete profileModalOpen={profileModalOpen} setProfileModalOpen={setProfileModalOpen}/>
        <div className="col-12 mt-2">
            <Alert 
            className="cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/profile")}
            variant={kycAlert}>
            {kycMessage}
            </Alert>
        </div>
            {loader ? <SearchDiamondSkeleton /> :""}
            <div className="row labTab" style={{ visibility: loader ? "hidden" : "visible" }}>
                <div className="col-12">
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialvalues}
                        onSubmit={async (values, {setFieldValue}) => {
                            enableLoading();
                            let oldvalues = values
                            oldvalues.diamond_type = "L"
                            Object.keys(values).forEach((key) => {
                                if (
                                    values[key] === "" ||
                                    values[key] === null ||
                                    values[key].length === 0
                                ) {
                                    delete values[key];
                                }
                            });
                            const error = validateFilters(values);

                            if (error) {
                                setErrorMsg(error);
                                showSearchToast("error", error);
                                disableLoading();
                                return;
                            }

                            setTimeout(() => {
                                handleData(values, oldvalues, setFieldValue);
                            }, 1000);
                        }}
                    >
                        {(formik, handleSubmit) => (
                            <>
                                <Form>
                                    <div className="card card-custom card-sticky gutter-b searchDiamondBox">
                                        <div className="card-header">
                                            <div className="card-title">{language.SEARCHDIAMOND_LABGROWN}</div>
                                            {userinfo.v_customer === "1" || userinfo.v_customer === "2" || userinfo.v_customer === "3"?<div className="card-toolbar">
                                                <div className="form-group mb-0 w-100">
                                                    <div className="input-group">
                                                        <Field
                                                            className="form-control"
                                                            type="text"
                                                            style={{width:"185px"}}
                                                            name="Certi_No"
                                                            id="Certi_No"
                                                            placeholder="certificate number search"
                                                            autoComplete="off"
                                                            onChange={(e) => handleInputChange(e,formik)}
                                                        />
                                                        <div className="input-group-append"><button className="input-group-text bg-whtite"><FaSearch /></button></div>
                                                    </div>
                                                </div>
                                            </div>:""}
                                        </div>
                                        <div className="card-body pt-0">
                                            <div className="row">
                                                <div className="col-12 mb-10">
                                                    <BasicLab errorMsg={errorMsg} setErrorMsg={setErrorMsg} formik={formik} language={language} option={location.option} setLoader={setLoader}/>
                                                </div>
                                                <div className="col-12 mb-10">
                                                    <Advanced language={language} formik={formik}/>
                                                </div>
                                                {/* <div className="col-12 mb-10">
                                                    <Preference language={language}/>
                                                </div> */}
                                                <div className="col-12 mb-10">
                                                    <Parameter language={language} formik={formik}/>
                                                </div>
                                                <div className="col-12 mb-10">
                                                    <AdditionalLab language={language} formik={formik}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="card-footer shadow-none natTab text-right border-top-0 sticky-top"
                                            style={{ bottom: "0",backgroundColor:"#f4f6fc" }}
                                        >
                                            <button
                                                type="reset"
                                                onClick={handelRest}
                                                disabled={isSubmitting}
                                                className={`btn btn-text-danger btn-hover-light-danger font-weight-bold px-10 ${isSubmitting ? "cursor-na" : ""}`}
                                            >
                                                RESET
                                            </button>
                                            <button
                                                type="submit"
                                                className={`btn btn-primary px-10  text-underline font-weight-bold ml-2 ${isSubmitting ? "cursor-na" : ""}`}
                                                disabled={isSubmitting}
                                                onClick={handleSubmit}
                                            >
                                                <FaSearch  className="mr-2 font-size-h5"/>
                                                {isSubmitting
                                                    ? "PLEASE WAIT..."
                                                    : "SEARCH"}
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </>
                        )}
                    </Formik>
                </div>
            </div>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <img alt="loader" src={toAbsoluteUrl(`/media/General/loading_lab.gif`)} />
            </Backdrop>
        </>
    );
};
